var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"14","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.5 19L8.5 12L15.5 5","stroke":"#787171","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }